var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2760_17473)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2760_17473",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 24,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2760_17473)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 24,
    rx: 2,
    fill: "#5DAA22"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-outside-1_2760_17473",
    maskUnits: "userSpaceOnUse",
    x: -7.5,
    y: -3,
    width: 48,
    height: 30,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -7.5,
    y: -3,
    width: 48,
    height: 30
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 12L32.5 0H0.5L16.5 12ZM16.5 12L0.5 24H32.5L16.5 12Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 12L32.5 0H0.5L16.5 12ZM16.5 12L0.5 24H32.5L16.5 12Z",
    fill: "#DD2C2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 0L34 2L40 -2.5H32.5V0ZM0.5 0V-2.5H-7L-1 2L0.5 0ZM0.5 24L-1 22L-7 26.5H0.5V24ZM32.5 24V26.5H40L34 22L32.5 24ZM31 -2L15 10L18 14L34 2L31 -2ZM0.5 2.5H32.5V-2.5H0.5V2.5ZM18 10L2 -2L-1 2L15 14L18 10ZM15 10L-1 22L2 26L18 14L15 10ZM0.5 26.5H32.5V21.5H0.5V26.5ZM34 22L18 10L15 14L31 26L34 22Z",
    fill: "white",
    mask: "url(#path-4-outside-1_2760_17473)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 18C19.8137 18 22.5 15.3137 22.5 12C22.5 8.68629 19.8137 6 16.5 6C13.1863 6 10.5 8.68629 10.5 12C10.5 15.3137 13.1863 18 16.5 18Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9301 10.3873L14.7681 10.4L15.3601 9.40002L14.7681 8.40002L15.9301 8.41275L16.5001 7.40002L17.0701 8.41275L18.2322 8.40002L17.6401 9.40002L18.2322 10.4L17.0701 10.3873L16.5001 11.4L15.9301 10.3873Z",
    fill: "#DD2C2C",
    stroke: "#5DAA22",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4301 14.4869L12.2681 14.4996L12.8601 13.4996L12.2681 12.4996L13.4301 12.5124L14.0001 11.4996L14.5701 12.5124L15.7322 12.4996L15.1401 13.4996L15.7322 14.4996L14.5701 14.4869L14.0001 15.4996L13.4301 14.4869Z",
    fill: "#DD2C2C",
    stroke: "#5DAA22",
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4301 14.4869L17.2681 14.4996L17.8601 13.4996L17.2681 12.4996L18.4301 12.5124L19.0001 11.4996L19.5701 12.5124L20.7322 12.4996L20.1401 13.4996L20.7322 14.4996L19.5701 14.4869L19.0001 15.4996L18.4301 14.4869Z",
    fill: "#DD2C2C",
    stroke: "#5DAA22",
    strokeWidth: 0.25
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2760_17473"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 32,
    height: 24,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBi);
export default __webpack_public_path__ + "static/media/BI.c627f2e6ea4a01c8bff06816eab52472.svg";
export { ForwardRef as ReactComponent };